import { LinearProgress } from "@material-ui/core";
import styled from "styled-components";

export const UploadLinearProgressBar = styled(LinearProgress)`
  margin-top: ${(props) => props.theme.spacing * 2}px;
  height: 16px;
  margin-bottom: ${(props) => props.theme.spacing}px;
`;
